import React, { Component } from "react";
import api from "../../services/api";
import axios from 'axios';
import Moment from 'moment';
import 'moment/locale/pt';
import './styles.css';
import { SwatchesPicker  } from 'react-color';


import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';

import 'bootstrap/dist/css/bootstrap.min.css';

import { Link } from 'react-router-dom';
import { withRouter } from "react-router-dom";

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";

import { FormGroup, Label, Input} from 'reactstrap';

import { ToastContainer, toast } from 'react-toastify';

  import 'react-toastify/dist/ReactToastify.css';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default class AddUserVIP extends Component {


    state = {
      tipo:"2",
      unidadenegocio_id2:"2",
      unidadenegocio_nome:"Acesso VIP",
      cor:"#666",
      nome:"",
      email:"",
      senha:"",
      open: true,
      redirect: false
      };

      async componentDidMount(){

      };


      handleChange_nome = (event) => {
        this.setState({nome: event.target.value});
      };

      handleChange_email = (event) => {
        this.setState({email: event.target.value});
      };

      handleChange_senha = (event) => {
        this.setState({senha: event.target.value});
      };



      handleSubmit = event => {
        event.preventDefault();
        const config = {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
        }
        };

      axios.post(`${process?.env?.REACT_APP_API_URL}/api/users`, {

        tipo:"2",
        unidadenegocio_id: "2",
        unidadenegocio_nome: "Acesso VIP",
        cor: "#666",
        nome: this.state.nome,
        email: this.state.email,
        senha: this.state.senha,
         }, config)
          .then(res => {
            alert('Usuário criado com sucesso!');
            this.props.history.push(`/uservip`);
          })
          .catch(function (error) {
            alert('Ocorreu algum erro!');
            console.log(error);
        });
      }


    render() {

      const popover = {
        position: 'absolute',
        zIndex: '2',
      }
      const cover = {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
      }

        const { open } = this.state;

        return (

          <Dialog fullScreen open={open} TransitionComponent={Transition}>
          <AppBar className="appBar" style={{backgroundColor:"#666",}}>
            <Toolbar>

            <table style={{width:"100%"}}>
                <tr>
                  <td align="left"><Typography variant="h6" className="title" style={{textTransform:"none"}}>
                    &nbsp; Criar usuário / VIP&nbsp;&nbsp;&nbsp;
                  </Typography>

              </td>
                  <td align="right">
                  <Link to={`/uservip`}>
              <IconButton edge="start" style={{color:'#fff'}} aria-label="close">
                <CloseIcon />
              </IconButton>
              </Link>
              </td>
                </tr>
              </table>





            </Toolbar>
          </AppBar>

          <div className="doadores-list2">
            <article>

              <form className="register-form" onSubmit={this.handleSubmit}>


              <GridContainer>

                  <GridItem xs={12} sm={12} md={4}>
                  <label htmlFor="nome">Nome completo</label>
                  <input className="input_text"
                  placeholder="Digite o nome completo do usuário..."
                    name="nome"
                    id="nome"
                    type="text"
                    required="required"
                    onChange={this.handleChange_nome}
                    />
                  </GridItem>

                  <GridItem xs={12} sm={12} md={4}>
                  <label htmlFor="email">E-mail</label>
                  <input className="input_text"
                  placeholder="Digite o e-mail de acesso..."
                    name="email"
                    id="email"
                    type="text"
                    required="required"
                    onChange={this.handleChange_email}
                    />
                  </GridItem>

                  <GridItem xs={12} sm={12} md={4}>
                  <label htmlFor="senha">Senha</label>
                  <input className="input_text"
                  placeholder="Digite uma senha de acesso..."
                    name="senha"
                    id="senha"
                    type="text"
                    required="required"
                    onChange={this.handleChange_senha}
                    />
                  </GridItem>




                </GridContainer>


            <div style={{position:"absolute", right:20, marginTop:20}}>
            <table>
              <tr>
                <td style={{verticalAlign:"middle"}}>
                  <div className="actions">
                    <button type="submit" style={{width:120, fontWeight:400, fontSize:14, backgroundColor:"#333"}}> Salvar </button>
                  </div>
                </td>
            </tr>

            </table>
</div>





              </form>




            </article>
            </div>

        </Dialog>


        );
    }
}